import { Id, Identifiable } from "@planzone/dto";

type SecondaryCriteriaType =
  | "number"
  | "text"
  | "richText"
  | "date"
  | "list"
  | "document"
  | "link"
  | "resource";

type RoleId = Id;

type SecondaryCriteria = {
  type: SecondaryCriteriaType;
  name: string;
  labels: {
    fr: string;
    en: string;
  };
  options: Identifiable<SecondaryCriteria>[];
  accessRoles: {
    read: RoleId[];
    write: RoleId[];
  };
  attr: {
    [key: string]: string;
  };
};

const secondaryCriteria: SecondaryCriteria = {
  type: "text",
  name: "",
  labels: {
    fr: "",
    en: "",
  },
  options: [],
  accessRoles: {
    read: [],
    write: [],
  },
  attr: {},
};

export type { SecondaryCriteria, SecondaryCriteriaType };

export { secondaryCriteria };
